export const COLUMN_LOCALSTORAGE_KEY = 'order-management:columns';
